import React, { Fragment } from 'react';
import HeaderBotton from '../../../components/HeaderBottom';
import HeaderTop from '../../../components/HeaderTop';
import Breadcumb from '../../../components/Breadcumb';
import FooterArea from '../../../components/FooterArea';
import ContactArea from '../../../components/ContactArea';

// images
import breadcumb from '../../../images/breadcumb/about-us-bg.jpg';
import team from '../../../images/Attorneys-single/adam-fritzler-small-profile2.jpg';

import './style.scss';

const breadcumbMenu = [
  { name: 'Home', route: '/' },
  { name: 'About', route: '/about' },
  { name: 'Adam Fritzler' },
];
const teamMembarInfo = [
  { level: 'Positon: ', text: 'Lawyer' },
  {
    level: 'Practice Area: ',
    text: 'Family Law, Criminal Defence, Real Estate, Wills & Estates',
  },
  { level: 'Experience: ', text: '10 Years' },
  {
    level: 'Address: ',
    text: '2620 Mary Hill Road, Port Coquitlam, British Columbia',
  },
  { level: 'Phone: ', text: '604.927.2156' },
  { level: 'Email: ', text: 'adam@fritzlerlaw.ca' },
  { level: 'Fax: ', text: ' 604.927.2155' },
];
const teamContents = [
  'Admization Institute of Law andTechnology, Juzment School of Management,Cambridge',
  'Academy University School of Law, Boston, MA',
  'The Syntify High School Of New York',
  'Education & Court Admissions',
];

// const portfolioItem = [
//   { images: portfolio1, title: 'General Service', subtitle: 'Corporate' },
//   { images: portfolio2, title: 'Personal Issue', subtitle: 'General' },
//   { images: portfolio3, title: 'Business Accounting', subtitle: 'Business' },
// ];

const SingleTeamPage = () => {
  return (
    <Fragment>
      <header className='headerArea'>
        <HeaderTop className='headerTop' />
        <HeaderBotton className='headerBottomArea headerBottomAreaStyelTwo' />
      </header>
      <Breadcumb
        className='breadcumbArea'
        title='Adam Fritzler'
        breadcumbMenu={breadcumbMenu}
        background={breadcumb}
      />
      <div className='singleTeamArea'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-10 offset-lg-1 col-12'>
              <div className='row'>
                <div className='col-md-6 col-12'>
                  <div className='singleTeamImgWrap'>
                    <div className='singleTeamImg'>
                      <img src={team} alt='' />
                    </div>
                    <h4>Adam Fritzler</h4>
                  </div>
                </div>
                <div className='col-md-6 col-12'>
                  <div className='singleTeamContent'>
                    <h4>Information</h4>
                    <ul className='teamMembarInfo'>
                      {teamMembarInfo.map((teamInfo, i) => (
                        <li key={i}>
                          <span>{teamInfo.level}</span>
                          {teamInfo.text}
                        </li>
                      ))}
                    </ul>
                    {/* <ul className='socialShare'>
                      <li>
                        <a href='#'>
                          <i className='fa fa-facebook'></i>
                        </a>
                      </li>
                      <li>
                        <a href='#'>
                          <i className='fa fa-twitter'></i>
                        </a>
                      </li>
                      <li>
                        <a href='#'>
                          <i className='fa fa-linkedin'></i>
                        </a>
                      </li>
                      <li>
                        <a href='#'>
                          <i className='fa fa-google-plus'></i>
                        </a>
                      </li>
                    </ul> */}
                  </div>
                </div>
                <div className='col-12'>
                  <div className='singleTeamInfo'>
                    <h3>Personal Experience</h3>
                    <p>
                      Mr. Adam Fritzler grew up on a farm in rural Saskatchewan.
                      He studied at the College of Agriculture at the University
                      of Saskatchewan and received his B. Sc. in 2007. In 2010
                      he convocated from the College of Law at the University of
                      Saskatchewan.
                    </p>
                    <p>
                      Adam joined a small Regina firm in June of 2010 as an
                      articling student and signed the Rolls in June of 2011. He
                      spent ten years in private practice, representing clients
                      primarily in civil, criminal and family law litigation
                      before moving to Legal Aid Saskatchewan in 2020 to focus
                      on criminal and family law exclusively. In 2024 he
                      accepted a position with the British Columbia Prosecution
                      Service where he prosecutes offences under the Criminal
                      Code in provincial and superior court.
                    </p>
                    <p>
                      When away from practice, he enjoys the outdoors and is an
                      avid sportsman and conservationist.
                    </p>

                    <h3>Criminal Law</h3>
                    <p>
                      My experience includes a wide range of summary and
                      indictable offences including impaired driving, property
                      theft and mischief, drug possession and trafficking,
                      assaults, domestic violence, breaches of conditions,
                      weapons, the Firearms Act, sexual offences, homicide, and
                      property forfeitures.
                    </p>
                    <p>
                      You can find an outline of the criminal law process&nbsp;
                      <a
                        target='_blank'
                        href='/static/media/2018%20overview%20of%20the%20adult%20criminal%20justice%20system.pdf'
                      >
                        here
                      </a>
                    </p>
                    <h4>Criminal news and professional involvement:</h4>
                    <ul>
                      <li>
                        <a
                          href='https://www.cbc.ca/news/canada/saskatchewan/sgi-collect-data-impaired-driving-study-1.5060418'
                          target='_blank'
                        >
                          SGI Impaired Driving Study
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.thelawyersdaily.ca/articles/6115'
                          target='_blank'
                        >
                          Lawyer’s Daily re: R. v. Knoblauch
                        </a>
                      </li>
                      <li>
                        <a href='https://www.pressreader.com/canada/regina-leader-post/20140913/281638188407008'>
                          Regina Leader-Post: 2014-09-13 - Sentence on Assault
                          Conviction Reduced - PressReader
                        </a>
                      </li>
                      <li>
                        <a href='https://leaderpost.com/news/crime/toto-sentencing'>
                          Regina judge remarks on tragedy of homicide case |
                          Regina Leader Post
                        </a>
                      </li>
                    </ul>

                    <h3>Family Law</h3>
                    <p>
                      From 2010 to 2024 I assisted clients with issues related
                      to custody, access, and support. These matters can be
                      resolved through negotiation, through the court process,
                      or a combination of the two. In the negotiation process,
                      you control the outcome and create the solutions for you
                      and your family. In the court process, a judge of the
                      court will impose the solution after hearing the relevant
                      evidence and argument from lawyers. At any stage of the
                      court process, you can choose to agree instead of continue
                      through the courts.
                    </p>

                    <h3>Past Clients</h3>
                    <p>
                      I retain wills, powers of attorney and other estate
                      planning documents that prepared for clients during
                      private practice. If you have any questions about estate
                      planning documents or to discuss your matter please feel
                      free to email or call me
                    </p>
                    <p>
                      Clients I represented during my time with Legal Aid
                      Saskatchewan should contact the application centre or the
                      Regina Rural area office.
                    </p>
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Portfolio
                title="Participated Case"
                subTitle="Here Our Best Work"
                fullWidth={true}
                portfolioItem={portfolioItem}
                className="portfolioArea portfolioAreaStyleFour"
            /> */}
      <ContactArea className='contactArea' />
      {/*
      <NewsLetter className='newsLetterArea' />
      */}
      <FooterArea />
    </Fragment>
  );
};
export default SingleTeamPage;
